var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"main__box"},[_vm._v(_vm._s(_vm.$account.auth))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }